// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options, formDataBodySerializer } from '@hey-api/client-axios';
import type { RootGetError, RootGetResponse, GetReleaseNotesGetReleaseNotesPostError, GetReleaseNotesGetReleaseNotesPostResponse, UuidcheckUuidcheckPostData, UuidcheckUuidcheckPostError, UuidcheckUuidcheckPostResponse, GetAdminGetAdminPostData, GetAdminGetAdminPostError, GetAdminGetAdminPostResponse, GetAdminDataGetAdminDataPostData, GetAdminDataGetAdminDataPostError, GetAdminDataGetAdminDataPostResponse, GetAdminTypeGetAdminTypePostData, GetAdminTypeGetAdminTypePostError, GetAdminTypeGetAdminTypePostResponse, UpdateRatingUpdateRatingPostData, UpdateRatingUpdateRatingPostError, UpdateRatingUpdateRatingPostResponse, GetPlanStatusGetPlanStatusPostData, GetPlanStatusGetPlanStatusPostError, GetPlanStatusGetPlanStatusPostResponse, GetIsSubscribedGetIsSubscribedPostData, GetIsSubscribedGetIsSubscribedPostError, GetIsSubscribedGetIsSubscribedPostResponse, CancelPlanCancelPlanPostData, CancelPlanCancelPlanPostError, CancelPlanCancelPlanPostResponse, ChangePlanChangePlanPostError, ChangePlanChangePlanPostResponse, GetUserQuotaGetUserQuotaPostData, GetUserQuotaGetUserQuotaPostError, GetUserQuotaGetUserQuotaPostResponse, GetQueryParcelCountsGetQueryParcelCountsPostData, GetQueryParcelCountsGetQueryParcelCountsPostError, GetQueryParcelCountsGetQueryParcelCountsPostResponse, SetTutorialSetTutorialPostData, SetTutorialSetTutorialPostError, SetTutorialSetTutorialPostResponse, SigninSigninPostData, SigninSigninPostError, SigninSigninPostResponse, Signin2Signin2PostData, Signin2Signin2PostError, Signin2Signin2PostResponse, TrialVerifyEmailTrialVerifyEmailPostData, TrialVerifyEmailTrialVerifyEmailPostError, TrialVerifyEmailTrialVerifyEmailPostResponse, TrialResendOtpTrialResendOtpPostData, TrialResendOtpTrialResendOtpPostError, TrialResendOtpTrialResendOtpPostResponse, TrialVerifyOtpTrialVerifyOtpPostData, TrialVerifyOtpTrialVerifyOtpPostError, TrialVerifyOtpTrialVerifyOtpPostResponse, TrialDowngradePlanTrialDowngradePlanPostData, TrialDowngradePlanTrialDowngradePlanPostError, TrialDowngradePlanTrialDowngradePlanPostResponse, EnterpriseSalesInquiryEnterpriseSalesInquiryPostData, EnterpriseSalesInquiryEnterpriseSalesInquiryPostError, EnterpriseSalesInquiryEnterpriseSalesInquiryPostResponse, GetProfileGetProfilePostData, GetProfileGetProfilePostError, GetProfileGetProfilePostResponse, DeleteAccountDeleteAccountPostData, DeleteAccountDeleteAccountPostError, DeleteAccountDeleteAccountPostResponse, TwofactorauthTwofactorauthPostData, TwofactorauthTwofactorauthPostError, TwofactorauthTwofactorauthPostResponse, SendUserMessageSendUserMessagePostData, SendUserMessageSendUserMessagePostError, SendUserMessageSendUserMessagePostResponse, UpdateProfileUpdateProfilePostData, UpdateProfileUpdateProfilePostError, UpdateProfileUpdateProfilePostResponse, ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostData, ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostError, ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostResponse, UpdatePasswordUpdatePasswordPostData, UpdatePasswordUpdatePasswordPostError, UpdatePasswordUpdatePasswordPostResponse, ForgotPasswordForgotPasswordPostData, ForgotPasswordForgotPasswordPostError, ForgotPasswordForgotPasswordPostResponse, CreateNewUserCreateNewUserPostData, CreateNewUserCreateNewUserPostError, CreateNewUserCreateNewUserPostResponse, SignupSignupPostData, SignupSignupPostError, SignupSignupPostResponse, InitialQueryParcelInitialQueryParcelPostData, InitialQueryParcelInitialQueryParcelPostError, InitialQueryParcelInitialQueryParcelPostResponse, QueryParcelQueryParcelPostData, QueryParcelQueryParcelPostError, QueryParcelQueryParcelPostResponse, QueryApnsUploadfileQueryApnsUploadfilePostData, QueryApnsUploadfileQueryApnsUploadfilePostError, QueryApnsUploadfileQueryApnsUploadfilePostResponse, AddInitialParcelToRanchAddInitialParcelToRanchPostData, AddInitialParcelToRanchAddInitialParcelToRanchPostError, AddInitialParcelToRanchAddInitialParcelToRanchPostResponse, GetsoilsgeomGetsoilsgeomPostData, GetsoilsgeomGetsoilsgeomPostError, GetsoilsgeomGetsoilsgeomPostResponse, CreateRanchCreateRanchPostData, CreateRanchCreateRanchPostError, CreateRanchCreateRanchPostResponse, EditRanchEditRanchPostData, EditRanchEditRanchPostError, EditRanchEditRanchPostResponse, GetRanchesGetRanchesPostData, GetRanchesGetRanchesPostError, GetRanchesGetRanchesPostResponse, GetRanchesGeojsonGetRanchesGeojsonPostData, GetRanchesGeojsonGetRanchesGeojsonPostError, GetRanchesGeojsonGetRanchesGeojsonPostResponse, AddParcelToRanchAddParcelToRanchPostData, AddParcelToRanchAddParcelToRanchPostError, AddParcelToRanchAddParcelToRanchPostResponse, DeleteParcelFromRanchDeleteParcelFromRanchPostData, DeleteParcelFromRanchDeleteParcelFromRanchPostError, DeleteParcelFromRanchDeleteParcelFromRanchPostResponse, DeleteRanchDeleteRanchPostData, DeleteRanchDeleteRanchPostError, DeleteRanchDeleteRanchPostResponse, GetParcelsByRanchIdGetParcelsByRanchIdPostData, GetParcelsByRanchIdGetParcelsByRanchIdPostError, GetParcelsByRanchIdGetParcelsByRanchIdPostResponse, QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostData, QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostError, QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostResponse, GetSoilsPropsPtGetSoilsPropsPtPostData, GetSoilsPropsPtGetSoilsPropsPtPostError, GetSoilsPropsPtGetSoilsPropsPtPostResponse, QueryWatershedInfoPtQueryWatershedInfoPtPostData, QueryWatershedInfoPtQueryWatershedInfoPtPostError, QueryWatershedInfoPtQueryWatershedInfoPtPostResponse, GetAllLinksGetAllLinksPostData, GetAllLinksGetAllLinksPostError, GetAllLinksGetAllLinksPostResponse, UpdateParcelsHsUpdateParcelsHsPostData, UpdateParcelsHsUpdateParcelsHsPostError, UpdateParcelsHsUpdateParcelsHsPostResponse, GetAllPortfolioSummariesGetAllPortfolioSummariesPostError, GetAllPortfolioSummariesGetAllPortfolioSummariesPostResponse, GetPortfolioSummaryGetPortfolioSummaryPostData, GetPortfolioSummaryGetPortfolioSummaryPostError, GetPortfolioSummaryGetPortfolioSummaryPostResponse, GetExecutiveSummaryGetExecutiveSummaryPostData, GetExecutiveSummaryGetExecutiveSummaryPostError, GetExecutiveSummaryGetExecutiveSummaryPostResponse, InsertReportInsertReportPostData, InsertReportInsertReportPostError, InsertReportInsertReportPostResponse, GenerateReportDownloadTokenGenerateReportDownloadTokenPostData, GenerateReportDownloadTokenGenerateReportDownloadTokenPostError, GenerateReportDownloadTokenGenerateReportDownloadTokenPostResponse, DownloadReportDownloadReportTokenGetData, DownloadReportDownloadReportTokenGetError, DownloadReportDownloadReportTokenGetResponse, GetReportByRanchIdGetReportByRanchIdPostData, GetReportByRanchIdGetReportByRanchIdPostError, GetReportByRanchIdGetReportByRanchIdPostResponse, GetReportByReportIdGetReportByReportIdPostData, GetReportByReportIdGetReportByReportIdPostError, GetReportByReportIdGetReportByReportIdPostResponse, GetAllReportsGetAllReportsPostData, GetAllReportsGetAllReportsPostError, GetAllReportsGetAllReportsPostResponse, GetFloodFromWktGetFloodFromWktPostData, GetFloodFromWktGetFloodFromWktPostError, GetFloodFromWktGetFloodFromWktPostResponse, GetStateDistrictsGetStateDistrictsPostData, GetStateDistrictsGetStateDistrictsPostError, GetStateDistrictsGetStateDistrictsPostResponse, GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostData, GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostError, GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostResponse, GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostData, GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostError, GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostResponse, GetDwrNewsGetDwrNewsGetError, GetDwrNewsGetDwrNewsGetResponse, GetDwrNewsJsonGetDwrNewsJsonGetError, GetDwrNewsJsonGetDwrNewsJsonGetResponse, GetDwrBlogsJsonGetDwrBlogsJsonGetError, GetDwrBlogsJsonGetDwrBlogsJsonGetResponse, GeocodeGeocodeGetData, GeocodeGeocodeGetError, GeocodeGeocodeGetResponse, ReverseGeocodeReverseGeocodeGetData, ReverseGeocodeReverseGeocodeGetError, ReverseGeocodeReverseGeocodeGetResponse, AutocompleteAutocompleteGetData, AutocompleteAutocompleteGetError, AutocompleteAutocompleteGetResponse, PlaceDetailsPlaceDetailsGetData, PlaceDetailsPlaceDetailsGetError, PlaceDetailsPlaceDetailsGetResponse, UserFeedbackUserFeedbackPostData, UserFeedbackUserFeedbackPostError, UserFeedbackUserFeedbackPostResponse, FilterAutocompleteFilterAutocompletePostData, FilterAutocompleteFilterAutocompletePostError, FilterAutocompleteFilterAutocompletePostResponse, ApnAutocompleteApnAutocompletePostData, ApnAutocompleteApnAutocompletePostError, ApnAutocompleteApnAutocompletePostResponse, GetFilterCriteriaCountiesGetFilterCriteriaCountiesPostError, GetFilterCriteriaCountiesGetFilterCriteriaCountiesPostResponse, FilterCriteriaFilterCriteriaPostData, FilterCriteriaFilterCriteriaPostError, FilterCriteriaFilterCriteriaPostResponse, CreateSubscriptionCreateSubscriptionPostError, CreateSubscriptionCreateSubscriptionPostResponse, CreateCheckoutSessionCreateCheckoutSessionPostError, CreateCheckoutSessionCreateCheckoutSessionPostResponse, StripeWebhookStripeWebhookPostError, StripeWebhookStripeWebhookPostResponse, GetEnterpriseAdminGetEnterpriseAdminGetError, GetEnterpriseAdminGetEnterpriseAdminGetResponse, GetOrganizationUsersOrganizationOrganizationIdUsersGetData, GetOrganizationUsersOrganizationOrganizationIdUsersGetError, GetOrganizationUsersOrganizationOrganizationIdUsersGetResponse, CreateOrganizationUserOrganizationOrganizationIdUsersPostData, CreateOrganizationUserOrganizationOrganizationIdUsersPostError, CreateOrganizationUserOrganizationOrganizationIdUsersPostResponse, ExportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetData, ExportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetError, ExportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetResponse, ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostData, ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostError, ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostResponse, AutocompleteOrganizationOrganizationIdUsersAutocompleteGetData, AutocompleteOrganizationOrganizationIdUsersAutocompleteGetError, AutocompleteOrganizationOrganizationIdUsersAutocompleteGetResponse, GetOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetData, GetOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetError, GetOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetResponse, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutData, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutError, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutResponse, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteData, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteError, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteResponse, UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutData, UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutError, UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutResponse, OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostData, OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostError, OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostResponse, ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostData, ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostError, ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostResponse, VerifyInvitationVerifyInvitationTokenGetData, VerifyInvitationVerifyInvitationTokenGetError, VerifyInvitationVerifyInvitationTokenGetResponse, GetOrganizationInfoOrganizationInfoGetError, GetOrganizationInfoOrganizationInfoGetResponse, UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutData, UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutError, UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutResponse, UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutData, UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutError, UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutResponse, AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostData, AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostError, AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostResponse, GetPlaidLinkTokenGetPlaidLinkTokenGetError, GetPlaidLinkTokenGetPlaidLinkTokenGetResponse, AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostData, AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostError, AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostResponse, RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteData, RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteError, RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteResponse, UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutData, UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutError, UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutResponse, GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetData, GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetError, GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetResponse, DownloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetData, DownloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetError, DownloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetResponse, SocialiteCallBackSocialiteCallbackProviderPostData, SocialiteCallBackSocialiteCallbackProviderPostError, SocialiteCallBackSocialiteCallbackProviderPostResponse, InAppVerifyReceiptInAppVerifyReceiptPostData, InAppVerifyReceiptInAppVerifyReceiptPostError, InAppVerifyReceiptInAppVerifyReceiptPostResponse, AppleNotificationAppleNotificationPostError, AppleNotificationAppleNotificationPostResponse, AppleNotificationTestAppleNotificationTestPostError, AppleNotificationTestAppleNotificationTestPostResponse, AppleNotificationTestAppleNotificationTestGetData, AppleNotificationTestAppleNotificationTestGetError, AppleNotificationTestAppleNotificationTestGetResponse, GoogleNotificationGoogleNotificationPostError, GoogleNotificationGoogleNotificationPostResponse, GetPlanFeatureSettingsPlanFeatureSettingsGetError, GetPlanFeatureSettingsPlanFeatureSettingsGetResponse, AdminGetPlanFeatureSettingsAdminPlanFeatureSettingsGetError, AdminGetPlanFeatureSettingsAdminPlanFeatureSettingsGetResponse, AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostData, AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostError, AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostResponse, UpdateUserNotifyHsChangeUsersNotifyHsChangePutData, UpdateUserNotifyHsChangeUsersNotifyHsChangePutError, UpdateUserNotifyHsChangeUsersNotifyHsChangePutResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * Root
 */
export const rootGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<RootGetResponse, RootGetError, ThrowOnError>({
        ...options,
        url: '/'
    });
};

/**
 * Get Release Notes
 */
export const getReleaseNotesGetReleaseNotesPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<GetReleaseNotesGetReleaseNotesPostResponse, GetReleaseNotesGetReleaseNotesPostError, ThrowOnError>({
        ...options,
        url: '/get_release_notes'
    });
};

/**
 * Uuidcheck
 * Check if user has valid uuid
 */
export const uuidcheckUuidcheckPost = <ThrowOnError extends boolean = false>(options: Options<UuidcheckUuidcheckPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<UuidcheckUuidcheckPostResponse, UuidcheckUuidcheckPostError, ThrowOnError>({
        ...options,
        url: '/uuidcheck'
    });
};

/**
 * Get Admin
 * Check if `paid` user has current subscription and if `admin`.
 */
export const getAdminGetAdminPost = <ThrowOnError extends boolean = false>(options: Options<GetAdminGetAdminPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetAdminGetAdminPostResponse, GetAdminGetAdminPostError, ThrowOnError>({
        ...options,
        url: '/get_admin'
    });
};

/**
 * Get Admin Data
 * Populate `admin` panel from executive summaries and ratings tables
 */
export const getAdminDataGetAdminDataPost = <ThrowOnError extends boolean = false>(options: Options<GetAdminDataGetAdminDataPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetAdminDataGetAdminDataPostResponse, GetAdminDataGetAdminDataPostError, ThrowOnError>({
        ...options,
        url: '/get_admin_data'
    });
};

/**
 * Get Admin Type
 * Check if user has `admin` access (ability to view `admin` panel and change scores/executive summaries) or `elevated admin` access (ability to view `admin` panel, change scores/executive summaries, view analytics, and add users)
 */
export const getAdminTypeGetAdminTypePost = <ThrowOnError extends boolean = false>(options: Options<GetAdminTypeGetAdminTypePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetAdminTypeGetAdminTypePostResponse, GetAdminTypeGetAdminTypePostError, ThrowOnError>({
        ...options,
        url: '/get_admin_type'
    });
};

/**
 * Update Rating
 * Update GSA/Water Districts ratings
 */
export const updateRatingUpdateRatingPost = <ThrowOnError extends boolean = false>(options: Options<UpdateRatingUpdateRatingPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<UpdateRatingUpdateRatingPostResponse, UpdateRatingUpdateRatingPostError, ThrowOnError>({
        ...options,
        url: '/update_rating'
    });
};

/**
 * Get Plan Status
 * Stripe based plan status update
 */
export const getPlanStatusGetPlanStatusPost = <ThrowOnError extends boolean = false>(options: Options<GetPlanStatusGetPlanStatusPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetPlanStatusGetPlanStatusPostResponse, GetPlanStatusGetPlanStatusPostError, ThrowOnError>({
        ...options,
        url: '/get_plan_status'
    });
};

/**
 * Get Is Subscribed
 */
export const getIsSubscribedGetIsSubscribedPost = <ThrowOnError extends boolean = false>(options: Options<GetIsSubscribedGetIsSubscribedPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetIsSubscribedGetIsSubscribedPostResponse, GetIsSubscribedGetIsSubscribedPostError, ThrowOnError>({
        ...options,
        url: '/get_is_subscribed'
    });
};

/**
 * Cancel Plan
 */
export const cancelPlanCancelPlanPost = <ThrowOnError extends boolean = false>(options: Options<CancelPlanCancelPlanPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<CancelPlanCancelPlanPostResponse, CancelPlanCancelPlanPostError, ThrowOnError>({
        ...options,
        url: '/cancel_plan'
    });
};

/**
 * Change Plan
 */
export const changePlanChangePlanPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<ChangePlanChangePlanPostResponse, ChangePlanChangePlanPostError, ThrowOnError>({
        ...options,
        url: '/change_plan'
    });
};

/**
 * Get User Quota
 */
export const getUserQuotaGetUserQuotaPost = <ThrowOnError extends boolean = false>(options: Options<GetUserQuotaGetUserQuotaPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetUserQuotaGetUserQuotaPostResponse, GetUserQuotaGetUserQuotaPostError, ThrowOnError>({
        ...options,
        url: '/get_user_quota'
    });
};

/**
 * Get Query Parcel Counts
 */
export const getQueryParcelCountsGetQueryParcelCountsPost = <ThrowOnError extends boolean = false>(options: Options<GetQueryParcelCountsGetQueryParcelCountsPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetQueryParcelCountsGetQueryParcelCountsPostResponse, GetQueryParcelCountsGetQueryParcelCountsPostError, ThrowOnError>({
        ...options,
        url: '/get_query_parcel_counts'
    });
};

/**
 * Set Tutorial
 * Sets bool value whether or not `tutorial` (app walk-through) is displayed on log in
 */
export const setTutorialSetTutorialPost = <ThrowOnError extends boolean = false>(options: Options<SetTutorialSetTutorialPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<SetTutorialSetTutorialPostResponse, SetTutorialSetTutorialPostError, ThrowOnError>({
        ...options,
        url: '/set_tutorial'
    });
};

/**
 * Signin
 * Paying customers sign in (checks for Stripe subscription and status)
 */
export const signinSigninPost = <ThrowOnError extends boolean = false>(options: Options<SigninSigninPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<SigninSigninPostResponse, SigninSigninPostError, ThrowOnError>({
        ...options,
        url: '/signin'
    });
};

/**
 * Signin2
 * Sign In with OPT authentication
 */
export const signin2Signin2Post = <ThrowOnError extends boolean = false>(options: Options<Signin2Signin2PostData, ThrowOnError>) => {
    return (options?.client ?? client).post<Signin2Signin2PostResponse, Signin2Signin2PostError, ThrowOnError>({
        ...options,
        url: '/signin2'
    });
};

/**
 * Trial Verify Email
 */
export const trialVerifyEmailTrialVerifyEmailPost = <ThrowOnError extends boolean = false>(options: Options<TrialVerifyEmailTrialVerifyEmailPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<TrialVerifyEmailTrialVerifyEmailPostResponse, TrialVerifyEmailTrialVerifyEmailPostError, ThrowOnError>({
        ...options,
        url: '/trial_verify_email'
    });
};

/**
 * Trial Resend Otp
 */
export const trialResendOtpTrialResendOtpPost = <ThrowOnError extends boolean = false>(options: Options<TrialResendOtpTrialResendOtpPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<TrialResendOtpTrialResendOtpPostResponse, TrialResendOtpTrialResendOtpPostError, ThrowOnError>({
        ...options,
        url: '/trial_resend_otp'
    });
};

/**
 * Trial Verify Otp
 */
export const trialVerifyOtpTrialVerifyOtpPost = <ThrowOnError extends boolean = false>(options: Options<TrialVerifyOtpTrialVerifyOtpPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<TrialVerifyOtpTrialVerifyOtpPostResponse, TrialVerifyOtpTrialVerifyOtpPostError, ThrowOnError>({
        ...options,
        url: '/trial_verify_otp'
    });
};

/**
 * Trial Downgrade Plan
 */
export const trialDowngradePlanTrialDowngradePlanPost = <ThrowOnError extends boolean = false>(options: Options<TrialDowngradePlanTrialDowngradePlanPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<TrialDowngradePlanTrialDowngradePlanPostResponse, TrialDowngradePlanTrialDowngradePlanPostError, ThrowOnError>({
        ...options,
        url: '/trial_downgrade_plan'
    });
};

/**
 * Enterprise Sales Inquiry
 */
export const enterpriseSalesInquiryEnterpriseSalesInquiryPost = <ThrowOnError extends boolean = false>(options: Options<EnterpriseSalesInquiryEnterpriseSalesInquiryPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<EnterpriseSalesInquiryEnterpriseSalesInquiryPostResponse, EnterpriseSalesInquiryEnterpriseSalesInquiryPostError, ThrowOnError>({
        ...options,
        url: '/enterprise_sales_inquiry'
    });
};

/**
 * Get Profile
 */
export const getProfileGetProfilePost = <ThrowOnError extends boolean = false>(options: Options<GetProfileGetProfilePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetProfileGetProfilePostResponse, GetProfileGetProfilePostError, ThrowOnError>({
        ...options,
        url: '/get_profile'
    });
};

/**
 * Delete Account
 */
export const deleteAccountDeleteAccountPost = <ThrowOnError extends boolean = false>(options: Options<DeleteAccountDeleteAccountPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<DeleteAccountDeleteAccountPostResponse, DeleteAccountDeleteAccountPostError, ThrowOnError>({
        ...options,
        url: '/delete_account'
    });
};

/**
 * Twofactorauth
 */
export const twofactorauthTwofactorauthPost = <ThrowOnError extends boolean = false>(options: Options<TwofactorauthTwofactorauthPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<TwofactorauthTwofactorauthPostResponse, TwofactorauthTwofactorauthPostError, ThrowOnError>({
        ...options,
        url: '/twofactorauth'
    });
};

/**
 * Send User Message
 * `Contact Us` endpoint for landing page
 */
export const sendUserMessageSendUserMessagePost = <ThrowOnError extends boolean = false>(options: Options<SendUserMessageSendUserMessagePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<SendUserMessageSendUserMessagePostResponse, SendUserMessageSendUserMessagePostError, ThrowOnError>({
        ...options,
        url: '/send_user_message'
    });
};

/**
 * Update Profile
 */
export const updateProfileUpdateProfilePost = <ThrowOnError extends boolean = false>(options: Options<UpdateProfileUpdateProfilePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<UpdateProfileUpdateProfilePostResponse, UpdateProfileUpdateProfilePostError, ThrowOnError>({
        ...options,
        url: '/update_profile'
    });
};

/**
 * Change Password With Session Key
 */
export const changePasswordWithSessionKeyChangePasswordWithSessionKeyPost = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostResponse, ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostError, ThrowOnError>({
        ...options,
        url: '/change_password_with_session_key'
    });
};

/**
 * Update Password
 */
export const updatePasswordUpdatePasswordPost = <ThrowOnError extends boolean = false>(options: Options<UpdatePasswordUpdatePasswordPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<UpdatePasswordUpdatePasswordPostResponse, UpdatePasswordUpdatePasswordPostError, ThrowOnError>({
        ...options,
        url: '/update_password'
    });
};

/**
 * Forgot Password
 * Password reset request --> OTP
 */
export const forgotPasswordForgotPasswordPost = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordForgotPasswordPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<ForgotPasswordForgotPasswordPostResponse, ForgotPasswordForgotPasswordPostError, ThrowOnError>({
        ...options,
        url: '/forgot_password'
    });
};

/**
 * Create New User
 * `Hydra Score - Super User` create user endpoint
 */
export const createNewUserCreateNewUserPost = <ThrowOnError extends boolean = false>(options: Options<CreateNewUserCreateNewUserPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateNewUserCreateNewUserPostResponse, CreateNewUserCreateNewUserPostError, ThrowOnError>({
        ...options,
        url: '/create_new_user'
    });
};

/**
 * Signup
 */
export const signupSignupPost = <ThrowOnError extends boolean = false>(options: Options<SignupSignupPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<SignupSignupPostResponse, SignupSignupPostError, ThrowOnError>({
        ...options,
        url: '/signup'
    });
};

/**
 * Initial Query Parcel
 * Initial `pre-query` (green) parcel selection
 */
export const initialQueryParcelInitialQueryParcelPost = <ThrowOnError extends boolean = false>(options: Options<InitialQueryParcelInitialQueryParcelPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<InitialQueryParcelInitialQueryParcelPostResponse, InitialQueryParcelInitialQueryParcelPostError, ThrowOnError>({
        ...options,
        url: '/initial_query_parcel'
    });
};

/**
 * Query Parcel
 * Main platform function to return data based on user input of point (lat, lon), attribute(s) (county, apns list), or geometry (bounds or string).
 */
export const queryParcelQueryParcelPost = <ThrowOnError extends boolean = false>(options: Options<QueryParcelQueryParcelPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<QueryParcelQueryParcelPostResponse, QueryParcelQueryParcelPostError, ThrowOnError>({
        ...options,
        url: '/query_parcel'
    });
};

/**
 * Query Apns Uploadfile
 */
export const queryApnsUploadfileQueryApnsUploadfilePost = <ThrowOnError extends boolean = false>(options: Options<QueryApnsUploadfileQueryApnsUploadfilePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<QueryApnsUploadfileQueryApnsUploadfilePostResponse, QueryApnsUploadfileQueryApnsUploadfilePostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/query_apns_uploadfile/'
    });
};

/**
 * Add Initial Parcel To Ranch
 * Given and `inital` parcel query --> add to existing ranch or create ranch and add to.
 */
export const addInitialParcelToRanchAddInitialParcelToRanchPost = <ThrowOnError extends boolean = false>(options: Options<AddInitialParcelToRanchAddInitialParcelToRanchPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<AddInitialParcelToRanchAddInitialParcelToRanchPostResponse, AddInitialParcelToRanchAddInitialParcelToRanchPostError, ThrowOnError>({
        ...options,
        url: '/add_initial_parcel_to_ranch'
    });
};

/**
 * Getsoilsgeom
 * Given a geometry string return intersected soils data
 */
export const getsoilsgeomGetsoilsgeomPost = <ThrowOnError extends boolean = false>(options: Options<GetsoilsgeomGetsoilsgeomPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetsoilsgeomGetsoilsgeomPostResponse, GetsoilsgeomGetsoilsgeomPostError, ThrowOnError>({
        ...options,
        url: '/getsoilsgeom'
    });
};

/**
 * Create Ranch
 */
export const createRanchCreateRanchPost = <ThrowOnError extends boolean = false>(options: Options<CreateRanchCreateRanchPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateRanchCreateRanchPostResponse, CreateRanchCreateRanchPostError, ThrowOnError>({
        ...options,
        url: '/create_ranch'
    });
};

/**
 * Edit Ranch
 */
export const editRanchEditRanchPost = <ThrowOnError extends boolean = false>(options: Options<EditRanchEditRanchPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<EditRanchEditRanchPostResponse, EditRanchEditRanchPostError, ThrowOnError>({
        ...options,
        url: '/edit_ranch'
    });
};

/**
 * Get Ranches
 */
export const getRanchesGetRanchesPost = <ThrowOnError extends boolean = false>(options: Options<GetRanchesGetRanchesPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetRanchesGetRanchesPostResponse, GetRanchesGetRanchesPostError, ThrowOnError>({
        ...options,
        url: '/get_ranches'
    });
};

/**
 * Get Ranches Geojson
 * Get ranch(es) geojson for `All Ranches` map layer
 */
export const getRanchesGeojsonGetRanchesGeojsonPost = <ThrowOnError extends boolean = false>(options: Options<GetRanchesGeojsonGetRanchesGeojsonPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetRanchesGeojsonGetRanchesGeojsonPostResponse, GetRanchesGeojsonGetRanchesGeojsonPostError, ThrowOnError>({
        ...options,
        url: '/get_ranches_geojson'
    });
};

/**
 * Add Parcel To Ranch
 */
export const addParcelToRanchAddParcelToRanchPost = <ThrowOnError extends boolean = false>(options: Options<AddParcelToRanchAddParcelToRanchPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<AddParcelToRanchAddParcelToRanchPostResponse, AddParcelToRanchAddParcelToRanchPostError, ThrowOnError>({
        ...options,
        url: '/add_parcel_to_ranch'
    });
};

/**
 * Delete Parcel From Ranch
 */
export const deleteParcelFromRanchDeleteParcelFromRanchPost = <ThrowOnError extends boolean = false>(options: Options<DeleteParcelFromRanchDeleteParcelFromRanchPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<DeleteParcelFromRanchDeleteParcelFromRanchPostResponse, DeleteParcelFromRanchDeleteParcelFromRanchPostError, ThrowOnError>({
        ...options,
        url: '/delete_parcel_from_ranch'
    });
};

/**
 * Delete Ranch
 */
export const deleteRanchDeleteRanchPost = <ThrowOnError extends boolean = false>(options: Options<DeleteRanchDeleteRanchPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<DeleteRanchDeleteRanchPostResponse, DeleteRanchDeleteRanchPostError, ThrowOnError>({
        ...options,
        url: '/delete_ranch'
    });
};

/**
 * Get Parcels By Ranch Id
 */
export const getParcelsByRanchIdGetParcelsByRanchIdPost = <ThrowOnError extends boolean = false>(options: Options<GetParcelsByRanchIdGetParcelsByRanchIdPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetParcelsByRanchIdGetParcelsByRanchIdPostResponse, GetParcelsByRanchIdGetParcelsByRanchIdPostError, ThrowOnError>({
        ...options,
        url: '/get_parcels_by_ranch_id'
    });
};

/**
 * Query Soils Detail Ucdavis
 * Soils properties on parcel detail page as well as generated reports
 */
export const querySoilsDetailUcdavisQuerySoilsDetailUcdavisPost = <ThrowOnError extends boolean = false>(options: Options<QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostResponse, QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostError, ThrowOnError>({
        ...options,
        url: '/query_soils_detail_ucdavis'
    });
};

/**
 * Get Soils Props Pt
 */
export const getSoilsPropsPtGetSoilsPropsPtPost = <ThrowOnError extends boolean = false>(options: Options<GetSoilsPropsPtGetSoilsPropsPtPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetSoilsPropsPtGetSoilsPropsPtPostResponse, GetSoilsPropsPtGetSoilsPropsPtPostError, ThrowOnError>({
        ...options,
        url: '/get_soils_props_pt'
    });
};

/**
 * Query Watershed Info Pt
 * Get detailed parcel information for card view and property detail from DWR (with local fallbacks) based on parcel centroid lat/lon
 */
export const queryWatershedInfoPtQueryWatershedInfoPtPost = <ThrowOnError extends boolean = false>(options: Options<QueryWatershedInfoPtQueryWatershedInfoPtPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<QueryWatershedInfoPtQueryWatershedInfoPtPostResponse, QueryWatershedInfoPtQueryWatershedInfoPtPostError, ThrowOnError>({
        ...options,
        url: '/query_watershed_info_pt'
    });
};

/**
 * Get All Links
 */
export const getAllLinksGetAllLinksPost = <ThrowOnError extends boolean = false>(options: Options<GetAllLinksGetAllLinksPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetAllLinksGetAllLinksPostResponse, GetAllLinksGetAllLinksPostError, ThrowOnError>({
        ...options,
        url: '/get_all_links'
    });
};

/**
 * Update Parcels Hs
 */
export const updateParcelsHsUpdateParcelsHsPost = <ThrowOnError extends boolean = false>(options?: Options<UpdateParcelsHsUpdateParcelsHsPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<UpdateParcelsHsUpdateParcelsHsPostResponse, UpdateParcelsHsUpdateParcelsHsPostError, ThrowOnError>({
        ...options,
        url: '/update_parcels_hs'
    });
};

/**
 * Get All Portfolio Summaries
 */
export const getAllPortfolioSummariesGetAllPortfolioSummariesPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<GetAllPortfolioSummariesGetAllPortfolioSummariesPostResponse, GetAllPortfolioSummariesGetAllPortfolioSummariesPostError, ThrowOnError>({
        ...options,
        url: '/get_all_portfolio_summaries'
    });
};

/**
 * Get Portfolio Summary
 */
export const getPortfolioSummaryGetPortfolioSummaryPost = <ThrowOnError extends boolean = false>(options: Options<GetPortfolioSummaryGetPortfolioSummaryPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetPortfolioSummaryGetPortfolioSummaryPostResponse, GetPortfolioSummaryGetPortfolioSummaryPostError, ThrowOnError>({
        ...options,
        url: '/get_portfolio_summary'
    });
};

/**
 * Get Executive Summary
 */
export const getExecutiveSummaryGetExecutiveSummaryPost = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveSummaryGetExecutiveSummaryPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetExecutiveSummaryGetExecutiveSummaryPostResponse, GetExecutiveSummaryGetExecutiveSummaryPostError, ThrowOnError>({
        ...options,
        url: '/get_executive_summary'
    });
};

/**
 * Insert Report
 */
export const insertReportInsertReportPost = <ThrowOnError extends boolean = false>(options: Options<InsertReportInsertReportPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<InsertReportInsertReportPostResponse, InsertReportInsertReportPostError, ThrowOnError>({
        ...options,
        url: '/insert_report'
    });
};

/**
 * Generate Report Download Token
 */
export const generateReportDownloadTokenGenerateReportDownloadTokenPost = <ThrowOnError extends boolean = false>(options: Options<GenerateReportDownloadTokenGenerateReportDownloadTokenPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GenerateReportDownloadTokenGenerateReportDownloadTokenPostResponse, GenerateReportDownloadTokenGenerateReportDownloadTokenPostError, ThrowOnError>({
        ...options,
        url: '/generate_report_download_token'
    });
};

/**
 * Download Report
 */
export const downloadReportDownloadReportTokenGet = <ThrowOnError extends boolean = false>(options: Options<DownloadReportDownloadReportTokenGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<DownloadReportDownloadReportTokenGetResponse, DownloadReportDownloadReportTokenGetError, ThrowOnError>({
        ...options,
        url: '/download-report/{token}'
    });
};

/**
 * Get Report By Ranch Id
 */
export const getReportByRanchIdGetReportByRanchIdPost = <ThrowOnError extends boolean = false>(options: Options<GetReportByRanchIdGetReportByRanchIdPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetReportByRanchIdGetReportByRanchIdPostResponse, GetReportByRanchIdGetReportByRanchIdPostError, ThrowOnError>({
        ...options,
        url: '/get_report_by_ranch_id'
    });
};

/**
 * Get Report By Report Id
 */
export const getReportByReportIdGetReportByReportIdPost = <ThrowOnError extends boolean = false>(options: Options<GetReportByReportIdGetReportByReportIdPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetReportByReportIdGetReportByReportIdPostResponse, GetReportByReportIdGetReportByReportIdPostError, ThrowOnError>({
        ...options,
        url: '/get_report_by_report_id'
    });
};

/**
 * Get All Reports
 */
export const getAllReportsGetAllReportsPost = <ThrowOnError extends boolean = false>(options: Options<GetAllReportsGetAllReportsPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetAllReportsGetAllReportsPostResponse, GetAllReportsGetAllReportsPostError, ThrowOnError>({
        ...options,
        url: '/get_all_reports'
    });
};

/**
 * Get Flood From Wkt
 * Get FEMA flood data from Postgre DB
 */
export const getFloodFromWktGetFloodFromWktPost = <ThrowOnError extends boolean = false>(options: Options<GetFloodFromWktGetFloodFromWktPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetFloodFromWktGetFloodFromWktPostResponse, GetFloodFromWktGetFloodFromWktPostError, ThrowOnError>({
        ...options,
        url: '/get_flood_from_wkt'
    });
};

/**
 * Get State Districts
 */
export const getStateDistrictsGetStateDistrictsPost = <ThrowOnError extends boolean = false>(options: Options<GetStateDistrictsGetStateDistrictsPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetStateDistrictsGetStateDistrictsPostResponse, GetStateDistrictsGetStateDistrictsPostError, ThrowOnError>({
        ...options,
        url: '/get_state_districts'
    });
};

/**
 * Get Weather Plots From Pt
 * Get historic climate data and generate tables and graphs from point (lat, lon) and start/end dates (dts,dte)
 */
export const getWeatherPlotsFromPtGetWeatherPlotsFromPtPost = <ThrowOnError extends boolean = false>(options: Options<GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostResponse, GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostError, ThrowOnError>({
        ...options,
        url: '/get_weather_plots_from_pt'
    });
};

/**
 * Get Weather Plots From Geojson
 * Get historic climate data and generate tables and graphs from geojson string and start/end dates (dts,dte)
 */
export const getWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPost = <ThrowOnError extends boolean = false>(options: Options<GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostResponse, GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostError, ThrowOnError>({
        ...options,
        url: '/get_weather_plots_from_geojson'
    });
};

/**
 * Get Dwr News
 */
export const getDwrNewsGetDwrNewsGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDwrNewsGetDwrNewsGetResponse, GetDwrNewsGetDwrNewsGetError, ThrowOnError>({
        ...options,
        url: '/get_dwr_news'
    });
};

/**
 * Get Dwr News Json
 */
export const getDwrNewsJsonGetDwrNewsJsonGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDwrNewsJsonGetDwrNewsJsonGetResponse, GetDwrNewsJsonGetDwrNewsJsonGetError, ThrowOnError>({
        ...options,
        url: '/get_dwr_news_json'
    });
};

/**
 * Get Dwr Blogs Json
 */
export const getDwrBlogsJsonGetDwrBlogsJsonGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDwrBlogsJsonGetDwrBlogsJsonGetResponse, GetDwrBlogsJsonGetDwrBlogsJsonGetError, ThrowOnError>({
        ...options,
        url: '/get_dwr_blogs_json'
    });
};

/**
 * Geocode
 * Get point coordinates from address
 */
export const geocodeGeocodeGet = <ThrowOnError extends boolean = false>(options: Options<GeocodeGeocodeGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GeocodeGeocodeGetResponse, GeocodeGeocodeGetError, ThrowOnError>({
        ...options,
        url: '/geocode'
    });
};

/**
 * Reverse Geocode
 */
export const reverseGeocodeReverseGeocodeGet = <ThrowOnError extends boolean = false>(options: Options<ReverseGeocodeReverseGeocodeGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<ReverseGeocodeReverseGeocodeGetResponse, ReverseGeocodeReverseGeocodeGetError, ThrowOnError>({
        ...options,
        url: '/reverse_geocode'
    });
};

/**
 * Autocomplete
 * Google location API autocomplete restricted to California
 */
export const autocompleteAutocompleteGet = <ThrowOnError extends boolean = false>(options: Options<AutocompleteAutocompleteGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<AutocompleteAutocompleteGetResponse, AutocompleteAutocompleteGetError, ThrowOnError>({
        ...options,
        url: '/autocomplete'
    });
};

/**
 * Place Details
 */
export const placeDetailsPlaceDetailsGet = <ThrowOnError extends boolean = false>(options: Options<PlaceDetailsPlaceDetailsGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<PlaceDetailsPlaceDetailsGetResponse, PlaceDetailsPlaceDetailsGetError, ThrowOnError>({
        ...options,
        url: '/place_details'
    });
};

/**
 * User Feedback
 */
export const userFeedbackUserFeedbackPost = <ThrowOnError extends boolean = false>(options: Options<UserFeedbackUserFeedbackPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<UserFeedbackUserFeedbackPostResponse, UserFeedbackUserFeedbackPostError, ThrowOnError>({
        ...options,
        url: '/user_feedback'
    });
};

/**
 * Filter Autocomplete
 */
export const filterAutocompleteFilterAutocompletePost = <ThrowOnError extends boolean = false>(options: Options<FilterAutocompleteFilterAutocompletePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<FilterAutocompleteFilterAutocompletePostResponse, FilterAutocompleteFilterAutocompletePostError, ThrowOnError>({
        ...options,
        url: '/filter_autocomplete'
    });
};

/**
 * Apn Autocomplete
 */
export const apnAutocompleteApnAutocompletePost = <ThrowOnError extends boolean = false>(options: Options<ApnAutocompleteApnAutocompletePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<ApnAutocompleteApnAutocompletePostResponse, ApnAutocompleteApnAutocompletePostError, ThrowOnError>({
        ...options,
        url: '/apn_autocomplete'
    });
};

/**
 * Get Filter Criteria Counties
 */
export const getFilterCriteriaCountiesGetFilterCriteriaCountiesPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<GetFilterCriteriaCountiesGetFilterCriteriaCountiesPostResponse, GetFilterCriteriaCountiesGetFilterCriteriaCountiesPostError, ThrowOnError>({
        ...options,
        url: '/get_filter_criteria_counties'
    });
};

/**
 * Filter Criteria
 */
export const filterCriteriaFilterCriteriaPost = <ThrowOnError extends boolean = false>(options: Options<FilterCriteriaFilterCriteriaPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<FilterCriteriaFilterCriteriaPostResponse, FilterCriteriaFilterCriteriaPostError, ThrowOnError>({
        ...options,
        url: '/filter_criteria'
    });
};

/**
 * Create Subscription
 */
export const createSubscriptionCreateSubscriptionPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateSubscriptionCreateSubscriptionPostResponse, CreateSubscriptionCreateSubscriptionPostError, ThrowOnError>({
        ...options,
        url: '/create-subscription'
    });
};

/**
 * Create Checkout Session
 */
export const createCheckoutSessionCreateCheckoutSessionPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateCheckoutSessionCreateCheckoutSessionPostResponse, CreateCheckoutSessionCreateCheckoutSessionPostError, ThrowOnError>({
        ...options,
        url: '/create-checkout-session'
    });
};

/**
 * Stripe Webhook
 */
export const stripeWebhookStripeWebhookPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<StripeWebhookStripeWebhookPostResponse, StripeWebhookStripeWebhookPostError, ThrowOnError>({
        ...options,
        url: '/stripe_webhook'
    });
};

/**
 * Get Enterprise Admin
 */
export const getEnterpriseAdminGetEnterpriseAdminGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetEnterpriseAdminGetEnterpriseAdminGetResponse, GetEnterpriseAdminGetEnterpriseAdminGetError, ThrowOnError>({
        ...options,
        url: '/get_enterprise_admin'
    });
};

/**
 * Get Organization Users
 */
export const getOrganizationUsersOrganizationOrganizationIdUsersGet = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationUsersOrganizationOrganizationIdUsersGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOrganizationUsersOrganizationOrganizationIdUsersGetResponse, GetOrganizationUsersOrganizationOrganizationIdUsersGetError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users'
    });
};

/**
 * Create Organization User
 */
export const createOrganizationUserOrganizationOrganizationIdUsersPost = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationUserOrganizationOrganizationIdUsersPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateOrganizationUserOrganizationOrganizationIdUsersPostResponse, CreateOrganizationUserOrganizationOrganizationIdUsersPostError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users'
    });
};

/**
 * Export Organization Users Csv
 */
export const exportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGet = <ThrowOnError extends boolean = false>(options: Options<ExportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<ExportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetResponse, ExportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users/export'
    });
};

/**
 * Import Organization Users
 */
export const importOrganizationUsersOrganizationOrganizationIdUsersImportPost = <ThrowOnError extends boolean = false>(options: Options<ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostResponse, ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/organization/{organization_id}/users/import'
    });
};

/**
 * Autocomplete
 */
export const autocompleteOrganizationOrganizationIdUsersAutocompleteGet = <ThrowOnError extends boolean = false>(options: Options<AutocompleteOrganizationOrganizationIdUsersAutocompleteGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<AutocompleteOrganizationOrganizationIdUsersAutocompleteGetResponse, AutocompleteOrganizationOrganizationIdUsersAutocompleteGetError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users/autocomplete'
    });
};

/**
 * Get Organization User Detail
 */
export const getOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGet = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetResponse, GetOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users/{useruuid}'
    });
};

/**
 * Update Organization User
 */
export const updateOrganizationUserOrganizationOrganizationIdUsersUseruuidPut = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutResponse, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users/{useruuid}'
    });
};

/**
 * Update Organization User
 */
export const updateOrganizationUserOrganizationOrganizationIdUsersUseruuidDelete = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteData, ThrowOnError>) => {
    return (options?.client ?? client).delete<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteResponse, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users/{useruuid}'
    });
};

/**
 * Update Organization User Activation
 */
export const updateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPut = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutResponse, UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users/{useruuid}/activation'
    });
};

/**
 * Organization User Password Reset
 */
export const organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPost = <ThrowOnError extends boolean = false>(options: Options<OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostResponse, OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users/{useruuid}/password-reset'
    });
};

/**
 * Resend Invitation
 */
export const resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPost = <ThrowOnError extends boolean = false>(options: Options<ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostResponse, ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/users/{useruuid}/resend-invitation'
    });
};

/**
 * Verify Invitation
 */
export const verifyInvitationVerifyInvitationTokenGet = <ThrowOnError extends boolean = false>(options: Options<VerifyInvitationVerifyInvitationTokenGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<VerifyInvitationVerifyInvitationTokenGetResponse, VerifyInvitationVerifyInvitationTokenGetError, ThrowOnError>({
        ...options,
        url: '/verify/invitation/{token}'
    });
};

/**
 * Get Organization Info
 */
export const getOrganizationInfoOrganizationInfoGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOrganizationInfoOrganizationInfoGetResponse, GetOrganizationInfoOrganizationInfoGetError, ThrowOnError>({
        ...options,
        url: '/organization/info'
    });
};

/**
 * Update Organization Info
 */
export const updateOrganizationInfoOrganizationOrganizationIdUpdateInfoPut = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutResponse, UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/update-info'
    });
};

/**
 * Update Billing Contacts
 */
export const updateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPut = <ThrowOnError extends boolean = false>(options: Options<UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutResponse, UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/update-billing-contacts'
    });
};

/**
 * Add Payment Method Card
 */
export const addPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPost = <ThrowOnError extends boolean = false>(options: Options<AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostResponse, AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/add-payment-method/card'
    });
};

/**
 * Get Plaid Link Token
 */
export const getPlaidLinkTokenGetPlaidLinkTokenGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPlaidLinkTokenGetPlaidLinkTokenGetResponse, GetPlaidLinkTokenGetPlaidLinkTokenGetError, ThrowOnError>({
        ...options,
        url: '/get_plaid_link_token'
    });
};

/**
 * Add Payment Method Ach
 */
export const addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPost = <ThrowOnError extends boolean = false>(options: Options<AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostResponse, AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/add-payment-method/ach'
    });
};

/**
 * Remove Payment Method
 */
export const removePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDelete = <ThrowOnError extends boolean = false>(options: Options<RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteData, ThrowOnError>) => {
    return (options?.client ?? client).delete<RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteResponse, RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/delete-payment-method/{payment_method_id}'
    });
};

/**
 * Update Default Payment Method
 */
export const updateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutResponse, UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/update-default-payment-method/{new_default_payment_id}'
    });
};

/**
 * Get Billing History
 */
export const getBillingHistoryOrganizationOrganizationIdBillingHistoryGet = <ThrowOnError extends boolean = false>(options: Options<GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetResponse, GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/billing-history'
    });
};

/**
 * Download All Invoices
 */
export const downloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGet = <ThrowOnError extends boolean = false>(options: Options<DownloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<DownloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetResponse, DownloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetError, ThrowOnError>({
        ...options,
        url: '/organization/{organization_id}/download_all_invoices'
    });
};

/**
 * Socialite Call Back
 */
export const socialiteCallBackSocialiteCallbackProviderPost = <ThrowOnError extends boolean = false>(options: Options<SocialiteCallBackSocialiteCallbackProviderPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<SocialiteCallBackSocialiteCallbackProviderPostResponse, SocialiteCallBackSocialiteCallbackProviderPostError, ThrowOnError>({
        ...options,
        url: '/socialite/callback/{provider}'
    });
};

/**
 * In App Verify Receipt
 */
export const inAppVerifyReceiptInAppVerifyReceiptPost = <ThrowOnError extends boolean = false>(options: Options<InAppVerifyReceiptInAppVerifyReceiptPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<InAppVerifyReceiptInAppVerifyReceiptPostResponse, InAppVerifyReceiptInAppVerifyReceiptPostError, ThrowOnError>({
        ...options,
        url: '/in-app-verify-receipt'
    });
};

/**
 * Apple Notification
 */
export const appleNotificationAppleNotificationPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<AppleNotificationAppleNotificationPostResponse, AppleNotificationAppleNotificationPostError, ThrowOnError>({
        ...options,
        url: '/apple/notification'
    });
};

/**
 * Apple Notification Test
 */
export const appleNotificationTestAppleNotificationTestPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<AppleNotificationTestAppleNotificationTestPostResponse, AppleNotificationTestAppleNotificationTestPostError, ThrowOnError>({
        ...options,
        url: '/apple/notification/test'
    });
};

/**
 * Apple Notification Test
 */
export const appleNotificationTestAppleNotificationTestGet = <ThrowOnError extends boolean = false>(options?: Options<AppleNotificationTestAppleNotificationTestGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<AppleNotificationTestAppleNotificationTestGetResponse, AppleNotificationTestAppleNotificationTestGetError, ThrowOnError>({
        ...options,
        url: '/apple/notification/test'
    });
};

/**
 * Google Notification
 */
export const googleNotificationGoogleNotificationPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<GoogleNotificationGoogleNotificationPostResponse, GoogleNotificationGoogleNotificationPostError, ThrowOnError>({
        ...options,
        url: '/google/notification'
    });
};

/**
 * Get Plan Feature Settings
 */
export const getPlanFeatureSettingsPlanFeatureSettingsGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPlanFeatureSettingsPlanFeatureSettingsGetResponse, GetPlanFeatureSettingsPlanFeatureSettingsGetError, ThrowOnError>({
        ...options,
        url: '/plan-feature-settings'
    });
};

/**
 * Admin Get Plan Feature Settings
 */
export const adminGetPlanFeatureSettingsAdminPlanFeatureSettingsGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminGetPlanFeatureSettingsAdminPlanFeatureSettingsGetResponse, AdminGetPlanFeatureSettingsAdminPlanFeatureSettingsGetError, ThrowOnError>({
        ...options,
        url: '/admin/plan-feature-settings'
    });
};

/**
 * Admin Save Plan Feature Settings
 */
export const adminSavePlanFeatureSettingsAdminPlanFeatureSettingsPost = <ThrowOnError extends boolean = false>(options: Options<AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostResponse, AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostError, ThrowOnError>({
        ...options,
        url: '/admin/plan-feature-settings'
    });
};

/**
 * Update User Notify Hs Change
 */
export const updateUserNotifyHsChangeUsersNotifyHsChangePut = <ThrowOnError extends boolean = false>(options: Options<UpdateUserNotifyHsChangeUsersNotifyHsChangePutData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateUserNotifyHsChangeUsersNotifyHsChangePutResponse, UpdateUserNotifyHsChangeUsersNotifyHsChangePutError, ThrowOnError>({
        ...options,
        url: '/users/notify/hs-change'
    });
};